import { Row, Col, Card, CardBody } from "reactstrap";
import { FileText, DollarSign, Star, Award } from "react-feather";

const formatCurrency = (value) => {
  if (!value && value !== 0) return "COP 0";
  return `COP ${Number(value).toLocaleString(undefined, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  })}`;
};

const formatNumber = (value) => {
  if (!value && value !== 0) return "0";
  return Number(value).toLocaleString();
};

const StatsCards = ({ 
  totalOrders = 0, 
  totalSales = 0, 
  totalBonusPoints = 0, 
  totalRoyaltyPoints = 0 
}) => {
  const cards = [
    {
      title: "Órdenes Totales",
      value: formatNumber(totalOrders),
      subtitle: "Total en el período",
      icon: <FileText size={20} />,
      color: "#3B82F6",
      bg: "#EEF5FF",
    },
    {
      title: "Ventas Netas (sin comisiones)",
      value: formatCurrency(totalSales),
      subtitle: "Total en el período",
      icon: <DollarSign size={20} />,
      color: "#22C55E",
      bg: "#ECFDF3",
    },
    {
      title: "Puntos Totales de Bono",
      value: formatNumber(totalBonusPoints),
      subtitle: "Total en el período",
      icon: <Star size={20} />,
      color: "#7C3AED",
      bg: "#F5F3FF",
    },
    {
      title: "Puntos Totales de Regalías",
      value: formatNumber(totalRoyaltyPoints),
      subtitle: "Total en el período",
      icon: <Award size={20} />,
      color: "#F59E0B",
      bg: "#FFF7ED",
    },
  ];

  return (
    <Row>
      {cards.map((card, index) => (
        <Col lg="3" md="6" sm="6" xs="12" key={index} className="mb-3">
          <Card
            className="border-0 h-100"
            style={{
              borderRadius: 14,
              boxShadow: "0 2px 10px rgba(0,0,0,.05)",
            }}
          >
            <CardBody style={{ padding: "18px" }}>
              <div className="d-flex">
                <div
                  className="d-flex align-items-center justify-content-center me-3"
                  style={{
                    width: 46,
                    height: 46,
                    minWidth: 46,
                    borderRadius: 12,
                    background: card.bg,
                    color: card.color,
                  }}
                >
                  {card.icon}
                </div>
                <div className="flex-grow-1">
                  <div
                    style={{
                      fontSize: 13,
                      color: "#6B7280",
                      fontWeight: 600,
                    }}
                  >
                    {card.title}
                  </div>
                  <div
                    style={{
                      fontSize: 28,
                      fontWeight: 700,
                      color: "#111827",
                      marginTop: 4,
                      lineHeight: 1.1,
                    }}
                  >
                    {card.value}
                  </div>
                  <div
                    style={{
                      marginTop: 8,
                      fontSize: 11,
                      color: "#9CA3AF",
                    }}
                  >
                    {card.subtitle}
                  </div>
                </div>
              </div>
            </CardBody>
          </Card>
        </Col>
      ))}
    </Row>
  );
};

export default StatsCards;